<template>
  <div class="programming">
    <div class="programming_left" ref="programming_left" :style="leftDivStyle">
      <div class="programming_header">
        <span style="line-height: 24px">
             <span class="el-icon-back" title="返回目录" @click="goBack"></span>
             <span>{{resourceName}}</span>
        </span>


        <span class="currentValueBtn" v-if="userType <= 1">
           允许查看答案
           <el-switch
             v-model="showAnswer"
             active-value="1"
             inactive-value="0"
             @change="setShowAnswer"
             active-color="#1890FF"
             inactive-color="#D2D2D7"
           ></el-switch>
        </span>
      </div>
      <div class="bottomer">
        <div class="nava">
          <div class="nava_tool">
            <p class="nava_tool_p" v-for="(bar, bi) in menubar"  @click="nava_tool_click(bi)" :class="{activeP: toolTab === bi}" v-if="bar.show">
              <svg
                style="width: 18px;height: 18px;"
                class="icon svg-icon"
                aria-hidden="true"
              >
                <use :xlink:href="bar.icon"></use>
              </svg>
              <span class="nava_label">{{ bar.label }}</span>
            </p>
          </div>
          <div class="nava_menu" :class="{activeNava: toolTab >= 0}">
            <!-- 步骤 -->
            <div class="nava_steps" v-if="toolTab === 0">
              <template v-if="has">
                <p
                  class="nava_steps_p"
                  v-for="(item, index) in treeData"
                  :key="index"
                  @click="activeThisOne(item, index)"
                  :title="item.name">
                  <span>
                      <span class="nava_steps_span ">{{ index + 1 }}</span>
                      <span class="nava_steps_name">{{ item.name }}</span>
                    <!--                  <span style="color: #1890FF" v-if="item.event >= 0 && item.answer">【实操训练】</span>-->
                  </span>
                  <span></span>

                </p>
              </template>

              <el-empty v-else :image-size="50" description="本题未设置步骤"></el-empty>

            </div>
            <!-- 评分 -->
            <div v-else-if="toolTab === 1" style="height: 100%;padding: 19px;overflow: auto;">
              <div class="rateBox" v-if="totalScore >= 0 && has">
                <div style="padding-right: 10px;font-size: 12px;">完成度:</div>
                <el-rate
                  v-model="totalScore"
                  disabled
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate>
              </div>
              <div v-if="totalScore >= 0 && has" class="nava_score">
                <template v-if="has && treeData[0].event >= 0 && treeData[0].event < 100">
                  <div v-for="(item, index) in treeData" :key="index + 'score'">
                    <template v-if="item.answer">
                      <p class="nava_steps_p" :title="item.name">
                        <span style="flex: 1;">
                            <span class="nava_steps_span nava_steps_span_finish">{{ index + 1 }}</span>
                            <span class="nava_steps_name">{{ item.name }}</span>
                            <span style="color: #1890FF" v-if="item.event >= 0 && item.answer">【实操训练】</span>
                        </span>
                        <span v-if="item.eventWeight >= 0" style="display: flex;align-items: center;">
                            <el-rate
                              v-model="item.eventWeight"
                              disabled
                              text-color="#ff9900"
                              score-template="{value}">
                            </el-rate>
                          <span v-show="item.eventWeight < 5" class="el-icon-s-operation openBtnIcon" @click="openThisComment(item)"></span>
                        </span>
                      </p>
                      <!-- 除代码块外的 评分点展示 -->
                      <div class="nava_comment" :class="{ nava_comment_open: item.open }" v-if="item.answer && item.answer.itData && item.answer.itData[0]  && item.answer.itData[0].agreementList && item.eventWeight < 5">
                        <div style="margin: 5px 5px 5px 20px;background: #F8F8F8;padding: 0 10px ;" v-for="(aitem, aindex) in item.answer.itData[0].agreementList" :key="aindex + 'agreement'">
                          <template v-if="aitem.comment || aitem.title">
                            <p style="font-weight: 600;">{{ aitem.title }} </p>
                            <p style="word-break: break-all;line-height: 1.5;">{{ aitem.comment }}</p>
                          </template>
                          <p v-else>没有配置评分描述语</p>
                        </div>
                      </div>
                      <!-- 代码块的 评分点展示 -->
                      <div class="nava_comment" :class="{ nava_comment_open: item.open }" v-else-if="item.itData && item.eventWeight < 5">
                        <div style="margin: 5px 5px 5px 20px;background: #F8F8F8;padding: 0 10px ;" v-for="(aitem, aindex) in item.itData" :key="aindex + 'agreement'">
                          <template v-if="aitem.comment || aitem.title">
                            <p style="font-weight: 600;">{{ aitem.title }} </p>
                            <p v-if="!aitem.unitWeight" style="word-break: break-all;line-height: 1.5;">{{ aitem.comment }}</p>
                          </template>
                          <p v-else>没有配置评分描述语</p>
                        </div>
                      </div>
                      <!-- 样式问题，随后优化 -->
                      <el-empty v-else-if="Number(item.eventWeight) !== 5" :image-size="50" description="暂无评分"></el-empty>
                    </template>
                  </div>
                </template>
                <el-empty v-else :image-size="50" description="试题中事项未绑定步骤"></el-empty>
              </div>
              <el-empty v-else :image-size="50" description="暂无评分"></el-empty>
            </div>
            <!-- 笔记 -->
           <zlNotes v-else-if="toolTab === 2" :query="query"></zlNotes>
					 <!-- 讨论 -->
           <zlDiscuss v-else-if="toolTab === 3" :query="query"></zlDiscuss>
					 <!-- 提问 -->
           <putQuestions  v-else-if="toolTab === 4" :query="query" :resource="activeOne"></putQuestions>
            <!-- 答案 -->
            <div style="height: 100%;padding: 19px;" v-else-if="toolTab === 5">
              <div style=" height:calc(100% - 41px);overflow: auto;" v-if="has">
                <div style="font-size: 16px;font-weight: 600;color: #42414D;">参考答案</div>
                <template v-if="has && treeData[0].event >= 0 && treeData[0].event < 100">
                   <div v-for="(item, index) in treeData" :key="index + 'score'">
                  <template v-if="item.answer">
                    <p
                      class="nava_steps_p"
                      :title="item.name">
                    <span style="flex: 1;">
                        <span class="nava_steps_span nava_steps_span_finish">{{ index + 1 }}</span>
                        <span class="nava_steps_name">{{ item.name }}</span>
                        <span style="color: #1890FF" v-if="item.event >= 0 && item.answer">【实操训练】</span>
                    </span>
                    </p>
                    <div class="editorShowArea" v-if="item.selfContent" v-html="item.selfContent"></div>
                    <div class="editorShowArea" v-else>
                     <span style="font-size: 12px;color: #cccccc;">未设置答案</span>
                    </div>
                  </template>

                </div>
                </template>
                <el-empty v-else :image-size="50" description="试题中事项未绑定步骤"></el-empty>
              </div>
              <el-empty v-else :image-size="50" description="未设置步骤，答案需绑定在步骤上"></el-empty>
            </div>
          </div>
        </div>
        <div class="content" v-loading="loading">
          <div class="content_header activeRound"  v-if="has">
            <span class="item_activeRound">{{activeIndex + 1}}</span>
            <span class="item_label">{{ activeOne.name }}</span>
          </div>
          <div class="text_content">
            <div
              class="type6Item"
              v-for="(item, index) in activeOne.imageText"
              :key="index"
            >
              <template v-if="item">
                <div class="editorShowArea" v-html="item.value" v-if="item.type === 1"></div>
                <questionRender
                  v-else-if="item.type === 3"
                  :question="item"
                  :questionAnswer="item.questionAnswer">
                </questionRender>
                <!--                <img :style="{'width': item.styleOption.width? item.styleOption.width + '%':'50%'}"-->
                <!--                     v-else-if="item.type === 7" class="type6resouce" :src="item.value"/>-->
                <el-image
                  v-else-if="item.type === 7"
                  :style="{
                  width: item.styleOption.width
                    ? item.styleOption.width + '%'
                    : '50%',
                }"
                  class="type6resouce"
                  :src="item.value"
                  :preview-src-list="[item.value]">
                </el-image>
                <video
                  :style="{
                           'width': item.styleOption.width + '%',
                        }"
                  v-else-if="item.type === 10"
                  class="video-js type6resouce"
                  controls
                  preload="auto"
                  controlslist="nodownload"
                  data-setup="{'example_option':true}"
                >
                  <source :src="item.value" type="video/mp4" class="video"/>
                  <p class="vjs-no-js">不支持播放</p>
                </video>

                <code-compiler
                  :readPage="true"
                  ref="codeCompiler"
                  readOnly
                  :refresh="item.value"
                  v-else-if="item.type === 11"
                  v-model="item.value"
                ></code-compiler>
                <div v-else-if="item.type === 12">
                  <el-popover
                    placement="bottom"
                    trigger="click"
                  >
                    <span class="zl_button zl_blueButton" @click="handleImport(item.value)">下 载</span>
                    <el-button size="mini" slot="reference">{{ item.value }}</el-button>
                  </el-popover>
                </div>
              </template>
            </div>
          </div>
          <!-- 正确率统计 -->
          <div class="eventScoring" v-if="activeOne.rightNumber || activeOne.errorNumber">
            <div class="eventScoringL" @click="openEventScoring">
              <span class="el-icon-arrow-down" v-if="eventScoring"></span>
              <span class="el-icon-arrow-up" v-else></span>
            </div>
            <div class="eventScoringContent" :class="{eventScoringShow:eventScoring}">
              <div class="eventScoringHead">
                <span class="eventScoringHeadItem">
                  <span class="el-icon-success" style="color: #67C23A"></span>
                  <span class="eventScoringHeadNumber"> {{activeOne.rightNumber || 0}}</span>
                </span>
                <span class="eventScoringHeadItem">
                  <span class="el-icon-error" style="color: #F56C6C"></span>
                  <span class="eventScoringHeadNumber"> {{activeOne.errorNumber || 0}}</span>
                </span>
                <span class="eventScoringHeadItem">
                  <span class="el-icon-menu" style="color: #999999"></span>
                  <span class="eventScoringHeadNumber"> {{(activeOne.rightNumber + activeOne.errorNumber) || 0}}</span>
                </span>
              </div>
              <div v-if="platform === 'codeBlockOS'">
                <div class="agreementP" v-for="(ititem, itindex) in activeOne.itData" :key="itindex+'a'">
                    <span class="aptitle">
                        <span style="color: #666666;font-weight: 600;">{{ ititem.title? ititem.title : '评分点' + itindex+1 }}: </span>
                        <span v-if="!ititem.unitWeight">{{ ititem.comment }}</span>
                    </span>
                    <span>
                       <span v-if="ititem.unitWeight" class="el-icon-success" style="color: #67C23A"></span>
                       <span v-else class="el-icon-error" style="color: #F56C6C"></span>
                    </span>
                </div>
              </div>
              <div v-else>
                <div v-for="(ititem, itindex) in activeOne.itData" :key="itindex+'a'">
                  <p class="agreementP" v-for="(item, index) in ititem.agreementList" :key="index+'b'">
                    <span class="aptitle">
                        <span style="color: #666666;font-weight: 600;">{{ item.title? item.title : '评分点' + index+1 }}</span>
                        <span v-if="!item.unitWeight" >{{ item.comment }}</span>
                    </span>
                    <span>
                       <span v-if="item.unitWeight" class="el-icon-success" style="color: #67C23A"></span>
                       <span v-else class="el-icon-error" style="color: #F56C6C"></span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="content_footer">
            <span @click="prev" v-if="activeIndex > 0" class="courseSubBtn zl_button zl_whiteButton">上一步</span>
            <span @click="goToScore" class="courseSubBtn zl_button zl_blueButton" style="margin:0 20px">
              {{ treeData.length == 1 ? '测评' : activeOne.errorNumber ? '重新测评':'下一步'}}
            </span>
            <span v-if="activeOne.errorNumber && !isEnd" @click="next" class="skip">跳过</span>
            <span
              v-if="isEnd"
              @click="nextSection"
              class="nextSection">
              学习下一节
            </span>
          </div>
        </div>
        <div class="bottomerMask" v-if="toolTab >= 0" @click="toolTab = -1"></div>
      </div>
    </div>
    <div class="programming_line" @mousedown.stop="lineMove($event)">
    </div>
    <div class="programming_right">
      <it-env
        ref="itEnv"
        v-model="taskData"
        :iframe-src="getIframeUrl()"
        :platform-type="platform"
        :codeRefresh="bindingSort"
        :show-tools-box="true"
        @itEnvMessage="setLoading"
        @itEnvOutput="itEnvOutput"
        @itEnvScore="getITScore"
      ></it-env>
    </div>
    <zl-rate v-if="showRate" :nextClick="nextSection" :closeFn="closeFn" v-model="totalScore"></zl-rate>
    <temporary-interaction :common-data="getInteractionData()" :user-type="userType" :showToolsBox="showToolsBox" ></temporary-interaction>
    <office-re-edit
      :showToolsBox="showToolsBox && (String(userType) !== '2')"
      :tool-bt-status="[{isHide:getIsHide(),name:'prePage'},{isHide:getIsHide(),name:'nextPage'}]"
      :init-questions-request-data="getUploadFileData()"
      @prev="prev"
      @next="next"
      @openSide="openSide"
    >
    </office-re-edit>
  </div>
</template>

<script>
  import codeCompiler from "@/views/component/code_compiler";
  import zlNotes from "../component/zlNotes";
  import zlDiscuss from "./components/zlDiscuss";
  import putQuestions from "./components/putQuestions";
  import questionRender from "@/views/component/questionRender";
  import paperPreview from "@/views/component/paperPreview";
  import * as api from "@/api/newCourseApi";
  import * as sourceApi from "@/api/sourceApi";
  import * as courseApi from "@/api/courseApi";
  import * as questionApi from "@/api/questionApi";
  import qs from 'qs';
  // import zlRate from "@/views/component/zl_rate";
  import zlRate from "@/components/zl_rate";
  import officeReEdit from '@/views/szrt_revision/teachingDetail/list/classroom/officeReEdit'
  import TemporaryInteraction from "@/views/szrt_revision/teachingDetail/list/classroom/temporaryInteraction";
  import ItEnv from "@/views/szrt_revision/teachingDetail/list/classroom/itEnv";
  import {isLinuxLabOS} from "@/utils/utils";
  export default {
    name: "programming",
    components: {
      ItEnv,
      codeCompiler,
      zlNotes,
      zlDiscuss,
      putQuestions,
      questionRender,
      paperPreview,
      zlRate,
      officeReEdit,
      TemporaryInteraction
    },
    data() {
      return {
        userType: sessionStorage.getItem("userType"), //

        query: {},
        isStep: 0,   // 1是多步骤实操题  0是富文本全局实训
        resourceId: '',      // 试题ID
        questionId: '',     // 资源id
        catalogType: '',
        courseId: '',
        courseMold: '',
        classId: '',
        // menubar: [],
        showToolsBox:false,

        resourceName: '多步骤实操题',
        leftDivStyle: {
          width: '40%',
        },
        iframeAddress: '',
        taskData: '',
        output: '',  // 代码块执行后的输出结果

        treeData: [],
        toolTab: -2,
        toolTabBak:-2,
        activeOne: {},
        activeIndex: 0,
        //
        answer: [],
        platform: '',
        templeteCode: '',
        roles: '',
        isDrag: false,
        //
        eventScoring: false,
        //
        loading: false,

        isEnd: false, // 是否最后一步。展示跳到下一节的按钮
        activeNames: [], // 展开项
        totalScore: 0, // 总分
        timer: null,
        //
        score: {},
        showRate: false,
        //
        bindingEvent:{},
        bindingSort: 0,
        //
        answerRecord: [],
        //
        showAnswer: '0',  // 老师设置答案 能否查看
        isFinish: false,   //  是否完成了整个实操
        //
        has: false, // 多步骤富文本是否绑定了实操题
      }
    },
    watch: {
      activeIndex(val) {
        if (this.treeData.length) {
          if (val === this.treeData.length - 1) {
            this.isEnd = true;
          } else {
            this.isEnd = false;
          }
        } else {
          this.isEnd = true;
        }
      },
    },
    computed:{
      getUploadFileData(){
        return function(){
          return {
            catalogId: this.query.catalogId,
            classId: this.classId,
            courseId: this.courseId,
            userId:sessionStorage.getItem('userId')
          }
        }
      },
      getInteractionData() {
        return function () {
          return {
            catalogId: this.query.catalogId,
            classId: this.classId,
            courseId: this.courseId,
            catalogType:this.catalogType
          }
        }
      },
      getIframeUrl(){
        return function(){
          return this.iframeAddress
        }
      },
      getIsHide(){
        return function(){
          return ![1,2,8].includes(this.activeOne.szrtType)
        }
      },
      menubar(){
        return [
          {
            label: '步骤',
            icon: '#icon-buzhou',
            show: true,
          },
          {
            label: '评分',
            icon: '#icon-pingfen',
            show: true,
          },
					{
					  label: '笔记',
					  icon: '#icon-biji',
					  show: true,
					},
					{
					  label: '讨论',
					  icon: '#icon-taolun',
					  show: true,
					},
					{
					  label: '提问',
					  icon: '#icon-tiwen',
					  show: true,
					},
          {
            label: '答案',
            icon: '#icon-daan',
            show: this.userType < 2 || (this.showAnswer === '1' && this.isFinish),
          },

        ]
      }
    },
    created() {
      if (this.$route.query.query) {
        this.query = JSON.parse(this.$AES.AES_Decrypt(this.$route.query.query));
        this.catalogType = this.query.catalogType
        this.courseId = this.query.courseId
        this.courseMold = this.query.courseMold
        this.classId = this.query.classId
        this.isStep = this.query.isStep   // 1是多步骤实操题  0是富文本全局实训
        this.resourceName =  this.query.tagName

        if (this.userType === '2'){
          this.getAnswerShow()
        }
      }

      console.log('--query--',  this.query)

      this.init();

    },
    methods: {
      init(){
        if (this.query.id) {
          this.loading = true;
          if (this.isStep == 1){
            this.questionId = this.query.id;
            this.queryAnswer()
          }else if(this.isStep == 0){
            this.resourceId = this.query.id
            this.getImageTextByResource();    // 0是富文本全局实训
          }
          //如果是上课模式 则显示工具
          if (this.courseMold === 'startCourse'){
            this.showToolsBox = true
          }
        }else{
          this.$messageWarning('路由传参有误')
        }
      },

      // 查询是否可查看答案 （针对学生）
      getAnswerShow(){
        courseApi.isAnswerShow({
          classId: this.query.classId,
          courseId: this.query.courseId,
          catalogId: this.query.catalogId,
          resourceId: this.query.id,
          resourceType: 3, // 实操题，3
        }).then(res =>{
          if (res.code === '0'){
            this.showAnswer = String(res.data.status);
            this.isFinish = res.data.isFinish > 0;
          }else{
            this.showAnswer = '0';
            this.isFinish = false;
          }
        })
      },

      // 查询上次作答分数
      queryAnswer(data) {
        return courseApi.QueryAnswer({
          catalogId: this.catalogId,
          // resourceId: this.activeIndex,
          courseId: this.courseId,
          classId: this.classId,
          questionIds: [this.questionId]
        }).then(res => {

          if (res.code == 0) {
            if (res.data.length) {
              if (res.data[0].userAnswer){
                try {
                  this.score = JSON.parse(res.data[0].userAnswer);
                }catch (e) {
                  this.score = {};
                }
              }
              this.totalScore = res.data[0].score
            }

            if (this.isStep == 1){
              this.getImageTextByQuestion();   // 1是多步骤实操题
            }else{
              this.getImgText(JSON.parse(data.imageText))
            }
          }
        })
      },
      // 获取试题中的多步骤富文本
      getImageTextByQuestion(){
        questionApi.findQuestionStep(this.questionId).then(res => {
          if (res.code == 0) {
            if (res.data && res.data.stepJson) {
              try {
                this.getImgText(JSON.parse(res.data.stepJson));
              }catch (e) {
                this.$messageWarning('试题中的富文本内容解析失败');
                this.loading = false;
              }
            }else{
              this.$messageWarning('未获取到试题中的富文本内容');
              this.loading = false;
            }
          }else{
            this.loading = false;
          }
        })
      },
      // 处理富文本中的步骤，截取成多个富文本（按照设置的步骤截取）
      getImgText(stepJson){
        let arr = [];
        let key = 0;
        if (stepJson.length) {
          this.has = false;
          [].forEach.call(stepJson, item => {

            if (item.extendOption && item.extendOption.isIndexes && item.extendOption.indexText) {

              if (item.extendOption.event >= 0){
                this.has = true;
              }
              if (arr[key] && arr[key].imageText && arr[key].imageText.length) {
                arr[key].name = item.extendOption.indexText
                arr[key].event = item.extendOption.event
                arr[key].imageText.push(item)
              } else {
                arr[key] = {
                  name : item.extendOption.indexText,
                  event : item.extendOption.event,
                  imageText : [item]
                }
              }
              key++

            } else {

              if (arr[key] && arr[key].imageText && arr[key].imageText.length) {
                arr[key].imageText.push(item)
              } else {
                arr[key] = {
                  name : '',
                  event : '',
                  imageText : [item]
                }
              }
            }
          })


          if (arr.length) {
            // 判断最后一截 是否未定义
            if (arr.length === 1){
              if (!arr[0].name){
                arr[0].name = '未设置步骤'
              }
            }else if (!arr[arr.length - 1].name){
              // 如果有多截，把最后一截拿出来放到前面一截中
              let text = arr[arr.length - 1].imageText;
              arr.pop();
              arr[arr.length - 1].imageText = [...arr[arr.length - 1].imageText, ...text]
            }
            this.treeData = arr;
            for (const arrKey in this.score) {
              if (this.treeData[arrKey]){
                this.treeData[arrKey]['stepWeight'] = this.score[arrKey].stepWeight;
                this.treeData[arrKey]['eventWeight'] = this.score[arrKey].eventWeight;
              }
            }

            this.activeOne = this.treeData[0];

          } else {
            this.treeData = [];
          }

          // 获取试题信息
          this.getQuestion(this.questionId);
        }

      },
      // 获取试题信息
      getQuestion(questionId) {
        courseApi.getAnswer(questionId).then(res => {
          if (res.code == 0) {
            if (res.data && res.data.questions && res.data.questions.questionAnswer) {
              this.answer = JSON.parse(res.data.questions.questionAnswer);
              this.answer[0].dynmaicParamReqList.forEach((item) => {
                if (item.param === "roles") {
                  this.roles = item.value;
                } else if (item.param === "templeteCode") {
                  this.templeteCode = item.value;
                } else if (item.param === "platform") {
                  this.platform = item.value;
                }
              });
              this.treeData.forEach( aitem =>{
                this.answer.forEach( (titem, index) =>{
                  if (aitem.event === titem.value.formMapper){
                    aitem['answer'] = titem.value
                    aitem['selfContent'] = res.data.event[index] ? res.data.event[index].selfContent : '暂无内容'
                  }
                })
              })
              this.loading = false;
              if (this.platform === 'codeBlockOS') return
              this.openCompilerOS();
            }else{
              this.$messageWarning('获取试题出错');
              this.loading = false;
            }
          }else{
            this.$messageWarning(res.msg);
            this.loading = false;
          }
        })
      },

      // 保存作答记录
      saveRecord(status) {
        if (status === '不评分'){
          if ( this.treeData[this.activeIndex]['stepWeight'] || this.treeData[this.activeIndex]['eventWeight']){
            delete this.treeData[this.activeIndex]['stepWeight']
            delete this.treeData[this.activeIndex]['eventWeight']
          }
        }
        this.score = {};
        this.totalScore = 0;
        this.treeData.forEach((item, index) =>{
          if (item['stepWeight'] >= 0 || item['eventWeight'] >= 0){
            this.totalScore += item['stepWeight'];
            this.score[index] = {
              stepWeight: item['stepWeight'] || 0,
              eventWeight: item['eventWeight'] || 0,
            }
          }
        })

        let param = {
          "catalogId": this.query.catalogId,
          "courseId": this.query.courseId,
          "classId": this.query.classId,
          "teamId": 0,
          "examId": 0,
          "questionId": this.questionId,
          "questionType": 9, //** 试题类型 1:单选题,2:多选题,3:判断题,4:问答题,6:组合题,9:实操题 */
          "version": new Date().getTime(),
          "userAnswer": JSON.stringify(this.score),  // 步骤分
          "useTime": '', //
          "questionStatus": 0,
          "score": this.totalScore, // 总分
          "stepId": 0,
          "resourceId": this.questionId,  // 对于多步骤实操题，这里把步骤坐标作为ID
        }
        courseApi.SaveRecord(param).then(res => {
          if (res.code == 0) {
            if (this.userType === '2'){
              this.getAnswerShow()
            }
          } else {
            this.$message.warning(res.msg);
          }
        })
      },


      // 保存完成状态
      insertDirectory() {
        let param = {
          catalogId: this.query.catalogId, //当前学习的目录id
          courseId: this.query.courseId, //课程id
          resourceId: this.questionId,
          studySort: this.query.index,   //用于回显选中。
          classId: this.query.classId,
          isEnd: 1, // 0 未看完，1，已看完 。资源是否看完
          seatno: 1, //资源学习次数
          resProgress: 1, //这条资源最后一次学习的时间
          totalResNum: 1, //总资源数
          resourceType: 3,  // 是实操题
        }
        courseApi.insertDirectory(param);
      },

      // 查询富文本全局实训
      getImageTextByResource() {
        api.CategoryResourceFindById({id: this.resourceId}).then(res => {
          if (res.code == 0) {
            if (res.data && res.data.imageText) {
              this.resourceName = res.data.resourceName
              this.getResourceQuestion(res.data);
            }
          }
        })
      },

      // 富文本全局实训，获取绑定的试题id
      getResourceQuestion(data) {
        sourceApi.getResourceQuestion(data.resourceId).then(res => {
          if (res.code == "0") {
            if (res.data && res.data.questionId) {
              this.questionId = res.data.questionId;
              this.queryAnswer(data)
            }
          } else {
            this.$message.error(res.msg);
          }
        })
      },

      // 获取iframe地址
      openCompilerOS() {
        if (!this.platform) return this.$message.warning('该文本绑定的试题没有配置动态参数');
        this.iframeAddress = "";
        let productFlag = sessionStorage.getItem('productFlag'); //课程类型：1.课证融通、2.单项训练、3.综合实训、4.真实任务
        //  sourceId = examType_courseId_classId_examPlan_teamId_userId_courseType_setNumber;
        //  examType  2考试  3综合  4课证融通或单项  5测验  6大赛  15课证融通测评
        //  courseId  课程id，没有写 NONE
        //  classId   班级id，没有写 NONE
        //  examPlan   计划id 或者 考试id  没有写 NONE
        //  teamId    小组id，  没有写 NONE  与userId互斥
        //  userId    用户id，  没有写 NONE  与teamId互斥
        //  courseType   课程类型   1课程 2实训
        //  setNumber   重置次数，默认1

        let examType = 'NONE';
        if (productFlag === '1' || productFlag === '2'){  //课程类型：1.课证融通、2.单项训练
          examType = 4  // 4课证融通或单项
        }else if(productFlag === '3'){  //课程类型：3.综合实训
          examType = 3  // 3综合
        }

        let courseId = this.query.courseId || 'NONE';
        let classId = this.query.classId || 'NONE';
        let examPlan = 'NONE';
        let teamId = 'NONE';   // 测验里的测评没有小组，在综合实训中有。
        let userId = sessionStorage.getItem("userId");
        let courseType = this.query.catalogType || 'NONE';
        let setNumber = 1;

        let sourceId = `${examType}_${courseId}_${classId}_${examPlan}_${teamId}_${userId}_${courseType}_${setNumber}`;

        let params = {
          edu_token: localStorage.getItem("Authorization"),
          userId: sessionStorage.getItem("userId"),
          sourceId: sourceId,
          questionId: this.questionId,
          templeteCode: this.templeteCode,
          roleCodes: this.roles,
          timestamp: new Date().getTime(),
        };
        if (this.platform === "jupyterNoteBook") {
          //  编辑器1
          this.iframeAddress = process.env.VUE_APP_COS + "?" + qs.stringify(params);
        } else if (this.platform === "jupyterTerminals") {
          //   终端
          params['kernelType'] = 'terminals'
          this.iframeAddress = process.env.VUE_APP_COS + "?" + qs.stringify(params);
        } else if (isLinuxLabOS(this.platform)) {
          //  编译器2
          params['kernelType'] = 'vnc'
          this.iframeAddress = process.env.VUE_APP_LINUXHUB + '/hub/login' + "?" + qs.stringify(params);
        }
      },


      openSide(){
        this.nava_tool_click(this.toolTabBak)
      },
      // 打开或变比评分后错误项展示框
      openEventScoring() {
        this.eventScoring = !this.eventScoring;
      },

      // 切换菜单栏
      nava_tool_click(type) {
        this.toolTabBak = type
        if (this.toolTab === type) {
          this.toolTab = -1;
        } else {
          this.toolTab = type;
        }
      },
      // （ 评分模块中 ） 展开与收起评语
      openThisComment(item){
        this.$set(item, 'open', !item.open);
      },
      /** 轴挪动 */
      lineMove(ev) {
        this.toolTab = -1;
        let that = this;
        let screenX = ev.screenX;
        let refWidth = that.$refs.programming_left.offsetWidth;
        this.isDrag = true;
        document.body.style.userSelect = 'none'
        const iframe = document.querySelector('iframe')
        iframe.style.pointerEvents = 'none'
        document.body.onmousemove = e => {
          let width = e.screenX - screenX + refWidth
          that.$set(that.leftDivStyle, 'width', width + 'px');
          that.$forceUpdate();
        };
        window.onmouseup = () => {
          that.onmouseup()
        };
      },
      onmouseup() {
        console.log('执行onmouseup')
        this.isDrag = false;
        document.body.style.userSelect = 'text'
        document.body.onmousemove = null;
        window.onmouseup = null;
        const iframe = document.querySelector('iframe')
        iframe.style.pointerEvents = 'auto'
      },
      // 下 载
      handleImport(val) {
        // window.location.href = val;
        /* window.location.href 会清空iframe，所以改成了a标签下载 */

       this.$downloadFun(val)
      },
      activeThisOne(item, index) {
        this.activeIndex = index;
        this.activeOne = item;
        this.nava_tool_click(this.toolTab);
      },
      prev() {
        if (this.activeIndex === 0) return
        this.activeIndex -= 1;
        this.activeOne = this.treeData[this.activeIndex];
      },
      next() {
        if (this.activeIndex === this.treeData.length - 1) {
          this.showRate = true;  // 展示得分
          // this.$messageWarning('已是最后一步， 请进入下一节')
          return
        }
        this.activeIndex++;
        this.activeOne = this.treeData[this.activeIndex];
      },

      //  编程题评分
      goToScore() {

        if ( this.activeOne.event >= 0) {
          this.bindingEvent = null
          this.bindingSort = 0
          let answer = JSON.parse(JSON.stringify(this.answer)),
            params = {
              business: {
                "questionId": this.questionId,
                "userId": sessionStorage.getItem('userId'),
              },
              events: [],
              "text": {
                "code": this.taskData,
                "output": this.output
              }
            };

          [].forEach.call(answer, (item, index) => {
            if (this.activeOne.event === item.value.formMapper || item.timestamp === this.activeOne.event) {
              this.bindingEvent = item;
              this.bindingSort = index;
              if (!this.activeOne['itData']){
                if (item.value.itData) this.activeOne['itData'] = item.value.itData;
              }
            }
          });

          if (this.platform === "codeBlockOS") {

            let tScore = 0;
            if (this.bindingEvent){
              let event = {
                "scoreType": 1,
                "eventWeight": this.bindingEvent.eventWeight,
                "formName": this.bindingEvent.value.formName,
                "formMapper": this.bindingEvent.value.formMapper,
                "uuid": this.bindingEvent.timestamp,
                // "stand": {
                //   "aggrementMapper": {},
                //   "weightMapper": {},
                //   "unit": {}
                // }
              };
              params.events.push(event);
              [].forEach.call(this.bindingEvent.value.itData, (ititem, itindex) => {
                tScore += Number(ititem.weight)
                // params.events[0].stand.aggrementMapper[itindex] = ititem.aggrement;
                // params.events[0].stand.weightMapper[itindex] = ititem.weight;
                // let compareContext = [];
                // if (ititem.value){
                //   compareContext = ititem.value.split('‼')
                // }else if(ititem.path){
                //   compareContext = ititem.path.split('‼')
                // }
                // params.events[0].stand.unit[itindex] = {
                //   "compareContext": compareContext,
                //   "compareTo": ititem.compareTo
                // }
              })
            }

            if (tScore === 0) {
              this.saveRecord('不评分');
              this.next();
            } else {
              // 代码块评分
              courseApi.scoringCodeEntry(params).then(res => {
                this.resultScore( res.data, String(res.code) === '0')
              })
            }

          }
          else{

            let tScore = 0;

            if (this.bindingEvent){
              if (this.bindingEvent.modelType === 'It_prefabrication') return;

              if(this.bindingEvent.value && this.bindingEvent.value.itData && this.bindingEvent.value.itData[0] && this.bindingEvent.value.itData[0].agreementList){
                [].forEach.call(this.bindingEvent.value.itData[0].agreementList, (agreementItem) => {
                  tScore += Number(agreementItem.weight)
                })
              }
            }

            if (tScore === 0) {
              this.saveRecord('不评分');
              this.next();
            } else {
              this.$refs.itEnv.exeScore(params)
            }
          }

        }else{
          this.saveRecord('不评分');
          // 未绑定事项的步骤，直接跳过
          this.next();
        }
      },

      /* 代码块 评分返回数据的处理 */
      resultScore(res, success) {
        if (!success){
          res && this.$messageWarning(res)
          return this.next();
        }
        let rightNumber = 0;
        let errorNumber = 0;
        if (
          res.data &&
          res.data.length &&
          this.answer.length
        ) {

          this.treeData[this.activeIndex]['stepWeight'] = res.data[0].stepWeight/20;
          this.treeData[this.activeIndex]['eventWeight'] = res.data[0].stepWeight/res.data[0].eventWeight*5;

          if (res.data[0].unit) {
            [].forEach.call(res.data[0].unit, item => {
              if (item.unitWeight > 0) {
                this.$set(this.activeOne.itData[item.unitName], 'unitWeight', 1);
                rightNumber++
              } else {
                this.$set(this.activeOne.itData[item.unitName], 'unitWeight', 0);
                errorNumber++
              }
            })
          }

          this.$set(this.activeOne, 'rightNumber', rightNumber);
          this.$set(this.activeOne, 'errorNumber', errorNumber);
        }
        this.eventScoring = true;

        /* 保存分数 */
        this.saveRecord();

        if (this.isEnd || this.activeIndex === this.treeData.length - 1) {
          this.showRate = true;  // 展示得分
          this.insertDirectory();  // 保存本题完成状态
        } else {
          if (errorNumber === 0) this.next();
        }
      },

      goBack() {
        this.$router.replace({
          path: "/LearningDetails",
          query: this.query
        })
      },
      nextSection() {
        this.closeFn();
        this.$router.replace({
          path: "/LearningDetails",
          query: this.query
        })
      },
      closeFn(){
        this.showRate = false;
      },
      itEnvOutput(val){
        this.output = val;
      },
      setLoading(){
        this.loading = false
      },
      // jupyter评分返回
      getITScore( r, t ){

        if (t){
          let productFlag = sessionStorage.getItem('productFlag'); //课程类型：1.课证融通、2.单项训练、3.综合实训、4.真实任务
          let examType = 'NONE';
          if (productFlag === '1' || productFlag === '2'){  //课程类型：1.课证融通、2.单项训练
            examType = 4  // 4课证融通或单项
          }else if(productFlag === '3'){  //课程类型：3.综合实训
            examType = 3  // 3综合
          }

          let params = {
            "userId": sessionStorage.getItem('userId'),
            "examType": examType,
            "questionId": this.questionId,
            "courseId": this.query.courseId,
            "classId": this.query.classId,
          }
          courseApi.getITScoringResults(params).then(res =>{
            if (res.code === '0'){
              if (res.data && res.data.content){
                let content = JSON.parse(res.data.content); // 拿到评分详情

                let scoreObj = content.process[this.activeIndex];  // 拿到当前步骤的评分详情

                this.treeData[this.activeIndex]['stepWeight'] = scoreObj.stepWeight/20;
                this.treeData[this.activeIndex]['eventWeight'] = scoreObj.stepWeight/scoreObj.eventWeight*5;

                let rightNumber = 0;
                let errorNumber = 0;
                if (scoreObj.itemLogs){
                  scoreObj.itemLogs.forEach((item, index) =>{
                    if (item.resultType === 'all_right'){
                      this.$set(this.activeOne.itData[0].agreementList[index], 'unitWeight', 1);
                      rightNumber++
                    }else{
                      this.$set(this.activeOne.itData[0].agreementList[index], 'unitWeight', 0);
                      errorNumber++
                    }
                  })
                }

                this.$set(this.activeOne, 'rightNumber', rightNumber);
                this.$set(this.activeOne, 'errorNumber', errorNumber);
                this.saveRecord();

                this.eventScoring = true;

                if (this.isEnd || this.activeIndex === this.treeData.length - 1) {
                  this.showRate = true;  // 展示得分
                  this.insertDirectory();  // 保存本题完成状态
                } else {
                  if (errorNumber === 0) this.next();
                }

              } else {
                this.$set(this.activeOne, 'errorNumber', 1);
                if (this.isEnd || this.activeIndex === this.treeData.length - 1) {
                  this.showRate = true;  // 展示得分
                  this.insertDirectory();  // 保存本题完成状态
                }
                this.loading = false;
                this.$messageError(res.msg)
              }
            } else{
              this.loading = false;
              // this.$messageError(res.msg)
            }
          }).catch(err =>{
            this.loading = false;
            // this.$messageError(err)
          })
        }
        else{
          this.loading = false;
          this.$messageError('评分失败')
        }

      },

      // 老师管理员设置学生是否能查看答案
      setShowAnswer(val){
        let obj = {
          classId: this.query.classId,
          courseId: this.query.courseId,
          catalogId: this.query.catalogId,
          resourceId: this.query.id,
          resourceType: 3, // 实操题，3
          status: Number(val)
        };
        courseApi
          .isAnswers(obj)
          .then(rs => {
            if (rs.code == 0) {
              this.$messageSuccess("设置成功");
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
    beforeDestroy() {
      this.loading = false;
      this.iframeAddress = "";
      this.activeNames = [];
      clearTimeout(this.timer);
    },
  }
</script>

<style scoped lang="scss">

  .programming {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;

    span{
      display: inline-block;
    }

    /deep/ .el-rate {
      height: auto;
      line-height: initial;
      .el-rate__icon,
      .el-rate__decimal,
      .el-icon-star-on {
        font-size: 20px;
      }
    }


    .courseSubBtn {
      height: 32px;
      line-height: 32px;
      border-radius: 6px;
    }

    /* 左侧 */
    .programming_left {
      min-width: 70px;
      overflow: hidden;
      box-shadow: 7px 0px 7px -7px #e6e6e6;
      .programming_header {
        border-bottom: solid 1px #e5e5e5;
        height: 50px;
        /*background: #e3e7eb;*/
        color: #42414D;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        .el-icon-back {
          width: 33px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          background: #f9f9fb;
          font-weight: 600;
          font-size: 20px;
          cursor: pointer;
          border-radius: 3px;
          margin-right: 11px;
        }
        .currentValueBtn{
          font-size: 12px;
        }
      }

      .bottomer {
        height: calc(100% - 50px);
        position: relative;

        .nava {
          height: 100%;
          background: #ffffff;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          z-index: 20;

          .nava_tool {
            user-select: none;
            width: 70px;
            background: #2B3C4E;
            color: #ffffff;

            /* #2a83ed */

            .nava_tool_p {
              text-align: center;
              margin: 5px 0 ;
              padding: 30px 0;
              cursor: pointer;
              svg {
                fill:#ffffff;
              }
              .nava_label {
                display: block;
                margin-top: 5px;
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
                line-height: 12px;
              }
            }

            .activeP {
              background: url("../../../static/images/IT/banyuanbeijing.png") no-repeat right top;
              background-size: 60px 100%;
              .nava_label{
                color: #2B3C4E;
              }
              svg {
                fill: #2B3C4E;
              }
            }
          }

          .nava_menu {
            height: 100%;
            width: 0px;
            overflow: hidden;
            transition: all 0.3s ease;
            box-shadow: 7px 0px 7px -7px #e6e6e6;
            .rateBox {
              display: flex;
              line-height: 25px;
            }

            .nava_score {
              height: calc(100% - 95px);
              overflow-y: auto;
              margin-top: 19px;
              font-size: 12px;

              .nava_comment{
                height: 0;
                overflow: hidden;
              }
              .nava_comment_open{
                height: auto;
              }

              p {
                /*margin: 10px;*/
                line-height: 36px;
                display: flex;
                align-items: center;
              }
            }
          }
          .nava_steps{
            height: calc(100% - 39px);
            overflow: auto;
            padding: 19px;
          }
          .nava_steps_p{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: center;
            font-size: 12px;
            margin: 10px 0;
            height: 36px;
            line-height: 36px;
            cursor: pointer;
            .nava_steps_span{
              width: 16px;
              height: 16px;
              text-align: center;
              line-height: 16px;
              border-radius: 16px;
              box-shadow: 0px 1px 4px 0px rgba(19,110,194,0.19);
              border: solid 1px #cccccc;
            }
            .nava_steps_span_finish{
              background: #1890FF;
              color: #ffffff;
            }
            .nava_steps_name{
              margin-left: 10px;
              line-height: 16px;
              /*cursor: pointer;*/
            }
          }

          .activeNava {
            width: 520px;
          }

          .openBtnIcon{
            font-size: 16px;
            margin-left: 10px;
          }

        }

        .content {
          height: 100%;
          margin-left: 70px;
          display: flex;
          flex-direction: column;

          .content_header {
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .text_content {
            flex: 1;
            overflow-y: auto;
            border-top: solid 1px #e5e5e5;
            border-bottom: solid 1px #e5e5e5;
            padding: 10px;


            .type6Item {
              margin-bottom: 7px;
              width: 100%;
              overflow: hidden;
            }

            .type6resouce {
              display: inline-block;
              max-width: 100%;
            }

          }

          /* 事项评分 */
          .eventScoring {
            position: relative;
            left: 0;
            width: 100%;
            bottom: 0;

            .eventScoringL {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              background: #E6E8F1;
              border-radius: 4px 4px 0px 0px;
              padding: 0px 8px;
              top: -15px;
              cursor: pointer;
              height: 15px;
              width: 48px;
              text-align: center;
              z-index: 18;
            }


            .eventScoringContent {
              height: 0px;
              overflow: hidden;
              transition: all 0.3s ease;

              .eventScoringHead {
                height: 23px;
                background: #F5F5F7;
                text-align: right;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .eventScoringHeadItem {
                  padding: 0 10px;
                  display: flex;
                  align-items: center;
                }

                .eventScoringHeadNumber {
                  font-size: 12px;
                  color: #42414D;
                  padding-left: 3px;
                }
              }
            }

            .eventScoringShow {
              height: auto;
              min-height: 100px;
              max-height: 400px;
              overflow-y: auto;
              transition: all 0.3s ease;
            }
          }

          .content_footer {
            height: 50px;
            line-height: 38px;
            text-align: center;
            user-select: none;

            .skip {
              font-size: 12px;
              color: #cccccc;
              cursor: pointer;
            }

            .nextSection {
              font-size: 12px;
              color: #1890FF;
              cursor: pointer;
            }
          }
        }

        .bottomerMask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0, 0.49);
          z-index: 19;
        }


        .item_label {
          font-size: 14px;
          color: #42414D;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .activeRound {
          color: #1890FF;

          .item_activeRound {
            background: #1890FF;
            color: #ffffff;
            display: inline-block;
            border-radius: 16px;
            width: 16px;
            height: 16px;
            line-height: 15px;
            text-align: center;
            font-size: 11px;
            margin-right: 5px;
          }
        }
      }

      .item_round {
        display: inline-block;
        border-radius: 16px;
        width: 16px;
        height: 16px;
        line-height: 15px;
        text-align: center;
        background: #DCE0E9;
        color: #B6B6BB;
        font-size: 11px;
        margin-right: 5px;
      }

      .agreementP {
        padding: 10px;
        color: #42414D;
        display: flex;
        font-size: 12px;
        align-items: center;
        justify-content: space-between;

        .aptitle {
          flex: 1;
          word-break: break-all;
          margin-right: 20px;
          line-height: 1.2;
        }
      }
    }

    /* 右侧 */
    .programming_right {
      flex: 1;
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;

      .programming_right_mask {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 20000;
      }
    }

    /* 拖拽线 */
    .programming_line {
      width: 5px;
      height: 100%;
      background: rgba(24, 144, 255, 0.5);
      &:hover{
        cursor: ew-resize;
        background: rgba(24, 144, 255, 0.9);
      }
    }

  }
</style>
<style>
  .programming .el-collapse-item__content {
    padding-bottom: 4px;
  }
  .programming .el-switch__core {
    width: 30px !important;
    height: 16px;
  }
  .programming .el-switch__core::after {
    width: 14px;
    height: 14px;
    margin-top: -1px;
  }
  .programming .el-switch.is-checked .el-switch__core::after{
    margin-left: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/IT/programming.vue